import { useDispatch, useSelector } from "react-redux";
import RecentTransactions from "../../components/cards/RecentTransactions";
import StatCards from "../../components/cards/StatCards";
import MainContainer from "../../components/container/MainContainer";
import ActivityGraph from "../../components/graphs/ActivityGraph";
import { useEffect } from "react";
import {
  getOrgProjectReports,
  unsetOrganizations,
} from "../../features/organizationsSlice";
import Loading from "../../components/loading/Loading";
import {
  getNarativeReports,
  getProvinceReports,
} from "../../features/reportsSlice";
import { Table2 } from "lucide-react";
import { Link } from "react-router-dom";
import {
  getProjectRequests,
  unsetProjects,
} from "../../features/projectsSlice";

const ProvincialCouncilDashboard = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userInfo);
  const province = useSelector((state) => state.reports.province);
  const narratives = useSelector((state) => state.reports.naratives);
  const projects = useSelector((state) => state.projects.data);

  useEffect(() => {
    dispatch(getOrgProjectReports());
    dispatch(getProvinceReports());
    return () => {
      dispatch(unsetOrganizations());
    };
  }, []);

  useEffect(() => {
    if (user.id) {
      dispatch(
        getNarativeReports({
          limit: 10,
          offset: 0,
          community_id: user.community ? user.communities[0].id : null,
        })
      );
    }

    if (user.province_id) {
      dispatch(
        getProjectRequests({
          limit: 5,
          offset: 0,
          desk: "provincial",
          id: user.province_id,
        })
      );
    }
    return () => {
      dispatch(unsetProjects());
    };
  }, [user]);

  if (!user.id) {
    <Loading />;
  }

  return (
    <MainContainer>
      <div className="flex-1 w-full h-full  mb-5 text-text-1/70">
        {user.id && (
          <div className="flex-1 h-full ">
            <div className="border border-bkg2 p-2 rounded-md bg-content mb-3 font-roboto">
              <p className="text-lg font-roboto font-bold mb-2 text-center">
                Hello,
                <span className=" font-medium">
                  {" " + user.first_name + " " + user.last_name}
                </span>
              </p>

              <p>
                <span>{user.province?.name || "N/A"}</span>
              </p>
              <p>Role:{" " + user.role || "N/A"}</p>
            </div>

            <div className="flex flex-1 flex-col sm:flex-row sm:items-center sm:justify-between gap-5 mb-10 sm:h-auto">
              <StatCards
                title="Gross Revenue"
                value="$NA"
                trend="up"
                pillText="12.5%"
                period="From Jun 16th - Sep 16th"
              />
              <StatCards
                title="Total Amounts "
                value="$NA"
                trend="down"
                pillText="3.9%"
                period="Froom Jan 1 - Jul #rd"
              />
              <StatCards
                title="Gross Revenue"
                value="$NA"
                trend="up"
                pillText="30%"
                period="Previous 200 days"
              />
              {/* <StatCards
              title="Gross Revenue"
              value="$543.60"
              trend="up"
              pillText="16%"
            /> */}
            </div>
            <div className="flex flex-1 flex-col sm:flex-row sm:items-center sm:justify-between gap-5 mb-5 sm:h-auto">
              {/* Table of Initatives For Community Title */}
              <div className="bg-content flex-1 shadow-lg h-60 rounded-lg p-3">
                <div className="flex items-center justify-between mb-4">
                  <h5 className="flex items-center gap-1.5 font-medium text-text-1/80">
                    <Table2 size={18} /> Provincial Approvals
                  </h5>
                  <Link
                    className="text-sm text-primary hover:underline"
                    to="/requests/provincial-approvals"
                  >
                    See all
                  </Link>
                </div>
                {/* The Table */}
                <div className="table-container w-full overflow-auto relative">
                  <table className="text-text-1/75">
                    <thead>
                      <tr className="text-text-1/80 sticky border-b border-b-text-2/50">
                        <th>No.</th>
                        <th>Title</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projects.map((item, index) => (
                        <tr key={index}>
                          <td>{++index}</td>
                          <td>
                            {item.name.length >= 20
                              ? item.name.slice(0, 25) + "....."
                              : item.name}
                          </td>
                          <td>{item.stage.step || "Not Started"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* Table for all Projects */}
              <div className="bg-content flex-1 shadow-lg h-60 rounded-lg p-3 overflow-auto">
                <h5 className="pb-2">Projects by Country</h5>
                <div className="table-container w-full overflow-auto relative">
                  <table className="text-text-1/75">
                    <thead>
                      <tr className="text-text-1/80 sticky border-b border-b-text-2/50">
                        <th>No.</th>
                        <th>Name</th>
                        <th>Request</th>
                        <th>Active</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {province.id &&
                        province.organizations.map((item, index) => (
                          <tr key={index}>
                            <td>{++index}</td>
                            <td>{item.country}</td>
                            <td>
                              {
                                item.projects.filter(
                                  (item) =>
                                    item.status.toLowerCase() === "request"
                                ).length
                              }
                            </td>
                            <td>
                              {
                                item.projects.filter(
                                  (item) =>
                                    item.status.toLowerCase() === "active"
                                ).length
                              }
                            </td>
                            <td>{item.projects.length}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="flex flex-1 flex-col sm:flex-row sm:items-center sm:justify-between gap-5 mb-5 sm:h-auto">
              <RecentTransactions narratives={narratives} />
            </div>
          </div>
        )}
      </div>
    </MainContainer>
  );
};

export default ProvincialCouncilDashboard;
